import React from "react";
import {Card, Col, Collapse, Row} from "antd";
import {MyBreadcrumb, MyImage, MyText} from "../../components";
import LogoImage from '../../assets/icons/logo.svg'
import {StyledCollapse} from "./index.styles";

export const Notification = () => {
  const items = [
    {
      key: '1',
      label: (
        <Row align='middle' justify='space-between'>
          <Col>
            <MyText size={18} weight={700}>
              Вам доступен документ, пройдите по ссылке
            </MyText>
          </Col>

          <Col>
            <MyText size={18} color='var(--c-icon)'>
              15.01.2023, 17:50
            </MyText>
          </Col>
        </Row>
      ),
      children: <p>Ваша заявка №135 от 02.09.2023 года решена, пожалуйста, проверьте в системе.</p>,
    },
    {
      key: '2',
      label: (
        <Row align='middle' justify='space-between'>
          <Col>
            <MyText size={18} weight={700}>
              Вам поступил ответ от Службы поддержки пользователей
            </MyText>
          </Col>

          <Col>
            <MyText size={18} color='var(--c-icon)'>
              15.01.2023, 17:50
            </MyText>
          </Col>
        </Row>
      ),
      children: <p>Ваша заявка №135 от 02.09.2023 года решена, пожалуйста, проверьте в системе.</p>,
    },
  ]

  return (
    <>
      <MyBreadcrumb title="Уведомления"/>

      <Row justify='center'>
        <Col span={20}>
          <Row>
            <Col span={24}>
              <Card>
                <Row gutter={[16, 32]}>
                  <Col span={24}>
                    <Row gutter={16} align='middle'>
                      <Col>
                        <MyImage src={LogoImage} width={28} height={32}/>
                      </Col>

                      <Col>
                        <MyText size={24} weight={500}>
                          Сообщения от технической поддержки пользователей
                        </MyText>
                      </Col>
                    </Row>
                  </Col>

                  <Col span={24}>
                    <StyledCollapse items={items} />
                  </Col>
                </Row>
              </Card>
            </Col>
          </Row>
        </Col>
      </Row>
    </>
  )
}